module.exports = __webpack_public_path__ + "static/img/logo.f819274c.svg";